export const scheduleEn = {
  common: {
    after: `After`,
    cancel: `Cancel`,
    clear: `Clear`,
    closed: `Closed`,
    create: `Create`,
    daily: `Daily`,
    delete: `Delete`,
    deleteError: {
      inUseGeneric: `This schedule cannot be deleted because it is in use by a switchboard. Remove it from the switchboard and try again.`,
      inUseMultiple: `This schedule cannot be deleted because it is used in switchboards: {{switchboardNames}}. Remove it from those switchboards and try again.`,
      inUseSingle: `This schedule cannot be deleted because it is used in switchboard: {{switchboardNames}}. Remove it from that switchboard and try again.`,
      listWithMore: `{{visibleNames}}, and {{remaining}} more`,
    },
    description: `Description`,
    edit: `Edit`,
    from: `from`,
    holiday: `Holiday`,
    monthly: `Monthly`,
    name: `Name`,
    never: `Never`,
    onDate: `On Date`,
    routing: `Routing`,
    save: `Save`,
    saving: `Saving...`,
    timeZone: `Time Zone`,
    to: `to`,
    validationErrorTitle: `Validation Error`,
    weekdayShort: {
      fri: `Fri`,
      mon: `Mon`,
      sat: `Sat`,
      sun: `Sun`,
      thu: `Thu`,
      tue: `Tue`,
      wed: `Wed`,
    },
    weekdayLong: {
      fri: `Friday`,
      mon: `Monday`,
      sat: `Saturday`,
      sun: `Sunday`,
      thu: `Thursday`,
      tue: `Tuesday`,
      wed: `Wednesday`,
    },
    weekly: `Weekly`,
    yearly: `Yearly`,
  },
  detail: {
    actions: {
      deleteScheduleModalTitle: `Delete schedule`,
      deleteScheduleTitle: `Delete Schedule`,
      editScheduleTitle: `Edit Schedule`,
    },
    currentRouting: `Current Routing:`,
    error: `Error`,
    header: {
      breadcrumbCurrent: `Edit Schedules`,
      breadcrumbRoot: `Schedules`,
    },
    hoursView: {
      calendar: `Calendar`,
      list: `List`,
    },
    loading: `Loading schedule...`,
    notFound: {
      description: `The schedule you are looking for does not exist.`,
      title: `Schedule not found`,
    },
    toast: {
      createOverrideFailedTitle: `Failed to create override`,
      createWeeklyHoursFailedTitle: `Failed to create weekly hours`,
      deleteEventFailedTitle: `Failed to delete event`,
      deleteScheduleFailedTitle: `Failed to delete schedule`,
      eventDeleted: `Event deleted successfully`,
      eventsUpdatedDescription: `Updated timezone for {{count}} event(s)`,
      eventsUpdatedTitle: `Events Updated`,
      failedTitle: `Failed`,
      genericError: `An error occurred`,
      holidaysAddFailed: `Failed to add {{count}} holiday(s)`,
      holidaysAddedSuccess: `{{count}} holidays added successfully`,
      holidaysAddedWithFailures: `{{successCount}} holidays added successfully ({{errorCount}} failed)`,
      loadEventsFailedDescription: `An error occurred while loading events`,
      loadEventsFailedTitle: `Failed to load schedule events`,
      loadScheduleFailedDescription: `An error occurred while loading the schedule`,
      loadScheduleFailedTitle: `Failed to load schedule`,
      overrideCreated: `Override created successfully`,
      overrideUpdated: `Override updated successfully`,
      scheduleDeleted: `Schedule deleted successfully`,
      scheduleUpdated: `Schedule updated successfully`,
      successTitle: `Success`,
      updateOverrideFailedTitle: `Failed to update override`,
      updateScheduleFailedTitle: `Failed to update schedule`,
      updateWeeklyHoursFailedTitle: `Failed to update weekly hours`,
      weeklyHoursCreated: `Weekly hours created successfully`,
      weeklyHoursUpdated: `Weekly hours updated successfully`,
    },
  },
  holidays: {
    actions: {
      addWithCount: `Add Holidays ({{count}})`,
    },
    common: {
      unknown: `Unknown`,
    },
    customPrompt: {
      link: `Set up your own special hours`,
      prefix: `Don't see the holiday you're looking for?`,
    },
    empty: `No preset holidays available`,
    error: {
      failedToLoad: `Failed to load holidays`,
    },
    loading: `Loading holidays...`,
    modal: {
      description: `Select the holiday presets you want to add to your override list. You can adjust the hours for each holiday by editing the event after it is created.`,
      title: `Add Preset Holidays`,
    },
    submitting: `Updating your schedule, this will just take a second.`,
    table: {
      holiday: `Holiday`,
      nextOccurrence: `Next Occurrence`,
    },
    validation: {
      noneSelectedDescription: `Please select at least one holiday to add`,
      noneSelectedTitle: `No holidays selected`,
    },
  },
  list: {
    card: {
      lastUpdated: `Last Updated`,
    },
    common: {
      notAvailable: `N/A`,
    },
    delete: `Delete`,
    deleteTitle: `Delete schedule`,
    empty: `No schedules found`,
    grid: {
      errorTitle: `Error`,
    },
    hoursVary: `Hours vary`,
    loading: `Loading schedules...`,
    newSchedule: `New Schedule`,
    noPermission: `You don't have permission to access schedules.`,
    noSchedules: `No Schedules found`,
    noSchedulesDescription: `Click on add new schedule to start adding your own availability`,
    pagination: {
      all: `All`,
      jumpToPage: `Jump to page {{page}}`,
      nextPage: `Next page`,
      previousPage: `Previous page`,
      resultsPerPage: `Results per page:`,
    },
    status: {
      closed: `Closed`,
      holiday: `Holiday`,
      openNow: `Open now`,
    },
    subtitle: `View and manage schedule configurations`,
    title: `Schedules`,
    toast: {
      createFailed: `Create failed`,
      createFailedDescription: `Failed to create schedule`,
      createSuccess: `Schedule created`,
      createSuccessDescription: `The schedule has been created successfully.`,
      deleteFailed: `Delete failed`,
      deleteFailedDescription: `Failed to delete schedule`,
      deleteSuccess: `Schedule deleted`,
      deleteSuccessDescription: `The schedule has been deleted successfully.`,
    },
    unavailable: `Unavailable`,
  },
  modal: {
    create: {
      cancel: `Cancel`,
      defaultWeeklyHoursLabel: `Include default weekly hours`,
      descriptionLabel: `Description`,
      descriptionPlaceholder: `Optional description for this schedule`,
      nameLabel: `Name`,
      namePlaceholder: `Business Hours`,
      saveSchedule: `Save Schedule`,
      saving: `Saving...`,
      timeZoneLabel: `Time Zone`,
      title: `New Schedule`,
      validationNameRequired: `Please enter a name for the schedule`,
      validationTitle: `Validation`,
    },
    deleteConfirmation: {
      cancel: `Cancel`,
      confirm: `Delete`,
      defaultBodyWithItemPrefix: `Are you sure you want to delete `,
      defaultBodyWithItemSuffix: `? This action cannot be undone.`,
      defaultBodyWithoutItem: `Are you sure you want to delete this item? This action cannot be undone.`,
      defaultTitle: `Delete item`,
    },
    editSchedule: {
      applyTimezoneChanges: `Apply Timezone Changes to:`,
      customEventsHelp: `Uncheck this option if you do not wish to update the timezone for existing Custom Events.`,
      customEventsWithCount: `Custom Events ({{count}})`,
      descriptionPlaceholder: `Optional description for this schedule`,
      namePlaceholder: `Business Hours`,
      timezoneWarning: `This will update your Weekly Hours to the selected timezone.`,
      title: `Edit Schedule`,
      updateSchedule: `Update Schedule`,
      validation: {
        nameRequired: `Please enter a name for the schedule`,
      },
    },
    override: {
      dateTime: `Date & Time`,
      dateType: {
        multipleDays: `Multiple Days`,
        singleDay: `Single Day`,
      },
      endRepeat: `End Repeat`,
      irregularRepeat: `This override has irregular repeat patterns and cannot be edited`,
      irregularRepeatNamed: `{{name}} has a repeat pattern that cannot be edited.`,
      irregularRepeatNextOccurrence: `Next occurrence is {{occurrence}}`,
      holidayTemplateCheckPending: `Checking {{name}} repeat pattern. Date and repeat controls are temporarily unavailable.`,
      holidayTemplateCheckUnavailable: `{{name}} repeat pattern could not be verified. Date and repeat controls are unavailable.`,
      loadingDetails: `Loading override details...`,
      monthly: {
        nthWeekday: `The {{nth}}{{suffix}} {{weekday}}`,
        specificDate: `The {{day}}{{suffix}}`,
      },
      namePlaceholder: `Override name`,
      startTimeAriaLabel: `From time`,
      startDateAriaLabel: `Start date`,
      endDateAriaLabel: `End date`,
      endRepeatDateAriaLabel: `End repeat date`,
      endTimeAriaLabel: `To time`,
      timePlaceholder: `h:mm`,
      meridiemAriaLabel: `{{label}} AM/PM`,
      meridiemOptionsAriaLabel: `{{label}} AM/PM options`,
      timeOptionsAriaLabel: `{{label}} options`,
      occurrences: `occurrences`,
      repeat: `Repeat`,
      repeatEvery: `Repeat Every`,
      repeatOn: `Repeat On`,
      repeatUnit: {
        days: `Day(s)`,
        months: `Month(s)`,
        weeks: `Week(s)`,
        years: `Year(s)`,
      },
      timeType: {
        closedAllDay: `Closed All Day`,
        setClosedHours: `Set Closed Hours`,
      },
      titleCreate: `Add Override`,
      titleEdit: `Edit Schedule Override`,
      validation: {
        endAfterStart: `End date/time must be after start date/time`,
        endDateRequired: `Please select an end date for multi-day events`,
        endDateRequiredShort: `Please select an end date`,
        invalidDateTime: `Please enter valid date and time values`,
        monthRequired: `Please select a month for yearly repeat`,
        monthlyPatternRequired: `Please select a monthly repeat pattern`,
        nameRequired: `Please enter a name for the override`,
        occurrencesRequired: `Please enter the number of occurrences`,
        startEndTimeRequired: `Please select start and end times`,
        validDayRequired: `Please select a valid day (1-31)`,
        validWeekdayPatternRequired: `Please select a valid weekday pattern`,
        weekdayRequired: `Please select at least one day of the week`,
      },
      yearly: {
        nthWeekday: `The {{nth}}{{suffix}} {{weekday}} of {{month}}`,
        specificDate: `The {{day}}{{suffix}} of {{month}}`,
      },
    },
  },
  overrides: {
    actions: {
      addHoliday: `Add Holiday`,
      addOverride: `Add Override`,
    },
    empty: `No schedule overrides configured`,
    item: {
      deleteHolidayTitle: `Delete holiday`,
      deleteOverrideModalTitle: `Delete override`,
      deleteOverrideTitle: `Delete Override`,
      editOverrideTitle: `Edit Override`,
      overrideInEffect: `Override in effect`,
      repeatsPrefix: `Repeats`,
    },
    title: `Schedule Overrides`,
  },
  status: {
    closed: `Closed`,
    holiday: `Holiday`,
    open: `Open`,
  },
  weeklyHours: {
    calendar: {
      confirmCreateDescription: `Create a new schedule entry for this selected time range?`,
      confirmCreateTitle: `Create schedule entry`,
      confirmDeleteTitle: `Delete time slot`,
      deleteEventLabel: `Delete {{day}} {{time}}`,
    },
    table: {
      confirmDeleteDayDescription: `Are you sure you want to delete all {{day}} time slots? This action cannot be undone.`,
      confirmDeleteDayItem: `{{day}} weekly hours`,
      confirmDeleteDayTitle: `Delete time slot`,
      confirmDeleteSlotItem: `{{day}} time slot`,
      confirmDeleteSlotTitle: `Delete time slot`,
      days: {
        friday: `Fridays`,
        monday: `Mondays`,
        saturday: `Saturdays`,
        sunday: `Sundays`,
        thursday: `Thursdays`,
        tuesday: `Tuesdays`,
        wednesday: `Wednesdays`,
      },
      slot: {
        addTitle: `Add schedule entry`,
        addDayLabel: `Add {{day}} hours`,
        deleteTitle: `Delete schedule entry`,
        deleteSlotLabel: `Delete {{day}} hours {{start}} to {{end}}`,
        endPlaceholder: `End`,
        startPlaceholder: `Start`,
        startTimeLabel: `{{day}} start time`,
        startTimeLabelNumbered: `{{day}} start time, entry {{number}}`,
        endTimeLabel: `{{day}} end time`,
        endTimeLabelNumbered: `{{day}} end time, entry {{number}}`,
        unavailable: `Unavailable`,
      },
      toggle: {
        disableDay: `Disable {{day}}`,
        enableDay: `Enable {{day}}`,
      },
    },
    timeSelect: {
      noTimesFound: `No times found`,
    },
  },
  queryError: {
    fetchSchedules: `Failed to fetch schedules`,
    fetchSchedule: `Failed to fetch schedule`,
    fetchEvents: `Failed to fetch schedule events`,
    fetchHolidays: `Failed to fetch schedule holidays`,
    createSchedule: `Failed to create schedule`,
    updateSchedule: `Failed to update schedule`,
    createEvent: `Failed to create schedule event`,
    updateEvent: `Failed to update schedule event`,
    deleteEvent: `Failed to delete schedule event`,
    generic: `Something went wrong. Please try again.`,
  },
} as const

type DeepStringRecord<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringRecord<T[K]>
}

export type ScheduleTranslation = DeepStringRecord<typeof scheduleEn>
